// Chat Widget Component (Refactored)
// Main chat widget that composes all sub-components
// Original: 1045 lines → Refactored: ~90 lines

import { useChatWidget } from './useChatWidget';
import ChatHeader from './ChatHeader';
import ChatMessages from './ChatMessages';
import ChatInput from './ChatInput';
import LanguageSelector from './LanguageSelector';
import CookieConsentBanner from './CookieConsentBanner';
import ChatToggleButton from './ChatToggleButton';

const ChatWidgetRefactored = () => {
  const {
    isOpen,
    setIsOpen,
    messages,
    messagesEndRef,
    inputValue,
    setInputValue,
    selectedDate,
    setSelectedDate,
    uploading,
    submitting,
    completed,
    showScheduler,
    setShowScheduler,
    selectedConsultDate,
    setSelectedConsultDate,
    availableSlots,
    selectedSlot,
    setSelectedSlot,
    smsConsent,
    setSmsConsent,
    showCookieBanner,
    cookieConsented,
    detectedLanguage,
    detectedLanguageName,
    showLanguageSelector,
    loadingTranslations,
    formData,
    setFormData,
    handleLanguageSelect,
    handleChangeLanguage,
    handleCookieConsent,
    handleAnswer,
    handleFileUpload,
    handleScheduleConsultation,
    fetchAvailableSlots,
    resetChat,
    getCurrentQuestion,
    getSavedLanguagePreference,
  } = useChatWidget();

  const question = getCurrentQuestion();

  return (
    <div className="chat-widget-container" data-testid="chat-widget">
      {/* Chat Window */}
      {isOpen && (
        <div className="chat-window bg-white rounded-2xl shadow-2xl border border-slate-200 mb-4 flex flex-col overflow-hidden">
          <ChatHeader
            detectedLanguage={detectedLanguage}
            detectedLanguageName={detectedLanguageName}
            showLanguageSelector={showLanguageSelector}
            onChangeLanguage={handleChangeLanguage}
            onClose={() => setIsOpen(false)}
          />

          {/* Language Selector - shown at start */}
          {showLanguageSelector && (
            <LanguageSelector
              onLanguageSelect={handleLanguageSelect}
              getSavedLanguagePreference={getSavedLanguagePreference}
              loadingTranslations={loadingTranslations}
              detectedLanguageName={detectedLanguageName}
            />
          )}

          {/* Messages */}
          {!showLanguageSelector && !loadingTranslations && (
            <ChatMessages
              messages={messages}
              submitting={submitting}
              completed={completed}
              messagesEndRef={messagesEndRef}
            />
          )}

          {/* Input Area - hidden during language selection */}
          {!showLanguageSelector && !loadingTranslations && (
            <div className="border-t border-slate-200 p-4">
              <ChatInput
                question={question}
                completed={completed}
                showScheduler={showScheduler}
                selectedConsultDate={selectedConsultDate}
                setSelectedConsultDate={setSelectedConsultDate}
                availableSlots={availableSlots}
                selectedSlot={selectedSlot}
                setSelectedSlot={setSelectedSlot}
                fetchAvailableSlots={fetchAvailableSlots}
                handleScheduleConsultation={handleScheduleConsultation}
                setShowScheduler={setShowScheduler}
                inputValue={inputValue}
                setInputValue={setInputValue}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                uploading={uploading}
                smsConsent={smsConsent}
                setSmsConsent={setSmsConsent}
                formData={formData}
                setFormData={setFormData}
                handleAnswer={handleAnswer}
                handleFileUpload={handleFileUpload}
                resetChat={resetChat}
              />
            </div>
          )}
        </div>
      )}

      {/* Cookie Consent Banner */}
      {isOpen && showCookieBanner && !cookieConsented && (
        <CookieConsentBanner
          onAccept={() => handleCookieConsent(true)}
          onDecline={() => handleCookieConsent(false)}
        />
      )}

      {/* Toggle Button */}
      <ChatToggleButton
        isOpen={isOpen}
        onClick={() => setIsOpen(!isOpen)}
      />
    </div>
  );
};

export default ChatWidgetRefactored;
